<template>
    <div class="title-and-upper-title">
        <div class="upper-title">{{ upperTitle }}</div>
        <h2 class="title">{{ title }}</h2>
    </div>
</template>

<script setup>

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    upperTitle: {
        type: String,
        required: true
    }
})
</script>

<style lang="scss" scoped>
.title-and-upper-title {
    text-align: center;
    max-width: 700px;
    margin: 200px auto 90px;

    & .upper-title {
        text-align: center;
        font-family: $tertiary-font-family;
        font-size: $upper-title-size;
        line-height: $upper-title-line-height;
        background: $title-background-gradient--blue;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    & .title {
        font-size: $title-size;
        line-height: 1.1em;
    }

    @media (min-width: 767px) {
        & .upper-title {
            font-size: 24px;
        }
        & .title {
            font-size: $desktop-title-size;
        }
    }

    
}
</style>